// import { ipcRenderer, remote } from 'electron'
// import isElectron from 'is-electron'
import { Component } from 'react'
import { connect } from 'react-redux'
import MalletStation from 'malletstation-js-api'
import { updatedDiff } from 'deep-object-diff'
import isEmpty from 'lodash.isempty'
import debounce from 'lodash.debounce'

import { newPreset, addToPreset, getPreset } from './presetBuilding'
import { buildMessage, pollPort } from '../../utilities'

import {
  deviceConnection,
  setBootloaderMode,
  firmwareUpdateComplete,
  devicePresetsLoaded,
  setStatusMessage,
  addPreset,
  selectUI,
  setBarRecord,
  setLearnStrikeCount
} from '../../actions/'

class MalletStationListener extends Component {
  malletStation = null
  rawVelocityBars = new Map()

  getBarFromMIDI(midi){
    // const { lowNote, octave, selectedLearnBar } = this.props
    // listen for note on / note off and velocity

    // set animation on selected bar
    // channel agnostic note on/off
    const messageType = midi[0] & 0xF0
          // note = midi[1],
          // velocity = midi[2]

    switch (messageType) {
      case 144:
      // get bar and velocity
      // need: lowNote, octave, selectedLearnBar
      // console.log('note', note, 'velocity', velocity, lowNote, octave, selectedLearnBar);
        break;
      case 128:
      // unselect bar
        break;
      default:
    }

  }

  componentDidMount() {
    try {
      navigator.requestMIDIAccess({sysex: true}).then(access => {
        const {
          onConnection,
          onReconnection,
          onDisconnection,
          onSetStatusMessage,
          onSetBootloaderMode,
          onDevicePresetsLoaded,
          onFirmwareUpdateComplete,
          onAddPreset,
          onSelectUI
        } = this.props

        this.malletStation = new MalletStation(access, false, false)
        // set global reference to malletStation
        window.malletStation = this.malletStation

        // set if in bootloader mode on connection
        if(window.malletStation.connection.bootloader.connected) {
          onSetBootloaderMode(true)
          onSetStatusMessage('bootloader')
          // set bootloader port
          window.malletStation._init()
        }

        // setup device message listeners
        // : connect
        this.malletStation.on('connectprimary', () => {
          onConnection('connected')
          /*
          if(isElectron()){
            const menu = remote.Menu.getApplicationMenu()
            menu.getMenuItemById('update_firmware').enabled = true
           }
           */
        })
        // : reconnect and secondaryconnect
        this.malletStation.on('connectsecondary', () => {
          onReconnection('connected')
          /*
          if(isElectron()){
            const menu = remote.Menu.getApplicationMenu()
            menu.getMenuItemById('update_firmware').enabled = true
           }
           */
        })
        this.malletStation.on('reconnect', () => {
          onReconnection('reconnected')
          /*
          if(isElectron()){
            const menu = remote.Menu.getApplicationMenu()
            menu.getMenuItemById('update_firmware').enabled = true
           }
           */
        })
        // : disconnection
        this.malletStation.on('disconnect', () => {
          onDisconnection(this.props.updatingFirmware ? 'updatingfirmware' : 'disconnected')
          /*
          if(isElectron()){
            const menu = remote.Menu.getApplicationMenu()
            menu.getMenuItemById('update_firmware').enabled = false
           }
           */
        })

        // firmware updating
        this.malletStation.on('firmwareupdatecomplete', () => {
          if(window.malletStation.connection.bootloader.initial) {
            // get malletStation ports
            window.malletStation._init()

            // wait till ports are connected
            Promise.all([
              pollPort(window.malletStation, window.malletStation.deviceName, 'input'),
              pollPort(window.malletStation, window.malletStation.deviceName, 'output')
            ]).then(() => {
              console.log('>> malletStation connected', window.malletStation.isConnected());
              onFirmwareUpdateComplete()
            })
          } else {
            onFirmwareUpdateComplete()
          }

          /*
          if(isElectron()){
            const menu = remote.Menu.getApplicationMenu()
            menu.getMenuItemById('update_firmware').enabled = true
           }
           */
        })

        //  : presets
        this.malletStation.on('presetbegin', (begin) => newPreset(begin))
        this.malletStation.on('presetchunk', (chunk) => addToPreset(chunk))
        this.malletStation.on('presetend', (end) => {
          onAddPreset('device', getPreset())
          if(end.values[0] === 4) onDevicePresetsLoaded(true)
        })

        // ui sync
        this.malletStation.on('ui', (control) => onSelectUI(control, this.props.presets, this.props.presetButtonsMode))

        // midi notes for selecting bars
        /*
        this.malletStation.on('midi', (midi) => {
          if(window.showMIDI) console.log('🎵 MIDI', [...midi])
        })
        */

        const debouncedLearn = debounce((values) => {
          const [debouncedBarIndex, debouncedVelocity] = values
          if(window.showDebounce) console.log('>> bar regulation: debounced', values);

          const isDebouncedBar = Array.from(this.rawVelocityBars).every(bar => {
            if(window.showDebounce) console.log(`>> debouncedBarIndex: ${debouncedBarIndex} index: ${bar[0]} debouncedVelocity: ${debouncedVelocity} velocity: ${bar[1]}`);
            return (debouncedBarIndex === bar[0]) ? true : debouncedVelocity > bar[1]
          })

          if(isDebouncedBar) {
            this.props.onSetBarRecord([debouncedBarIndex, debouncedVelocity])
            // this.props.onSetStrikeCount()
          }

          // reset map
          this.rawVelocityBars.clear()
        }, 200, {
          'leading': true,
          'trailing': false
        })

        //
        const debouncedClear = debounce(() => {
          this.rawVelocityBars.clear()
        }, 80, {
          'leading': false,
          'trailing': true
        })

        //
        this.malletStation.on('rawvelocity', (data) => {
          const [barIndex, rawVelocity] = data.values
          if(window.rawData) console.log('>> bar regulation: rawData', data.values);


          this.rawVelocityBars.set(barIndex, rawVelocity)



          if(this.props.selectedLearnBar !== data.values[0]) {
            if(window.showCrosstalk) console.log('>> bar regulation: crosstalk', data.values);
            debouncedClear()
            return
          }

          debouncedLearn(data.values)
        })
      })
    } catch(e) {
      console.warn('>> Web MIDI API is unsupported in this browser');
      alert("This browser doesn't currently support WebMIDI, please use Chrome, Opera, or Brave")
      this.props.onSetStatusMessage('web midi unsupported')
    }
  }

  componentDidUpdate(previousProps) {
    const difference = updatedDiff(previousProps.currentPreset, this.props.currentPreset)

    if(!isEmpty(difference) && Object.keys(difference).length === 1) { // if diff > 1; entire preset, ignore
      if(this.malletStation && this.malletStation.isConnected()){
        const [ param, values ] = buildMessage(difference, this.props.currentPreset)
        // send device param update
        this.malletStation.setParam(param, values)
      } else {
        // console.clear()
        console.warn(`>> cannot update ${Object.keys(difference)} on malletStation, device not connected`)
      }
    } else {
      // this also triggers on editor state changes like toggle bar gain mode
      // maybe this can trigger some action for preset change?
      // console.log('>> editor: currentPreset change');
    }
  }

  componentWillUnmount() {
    try {
      // cleanup event handlers
      this.malletStation && this.malletStation.removeAllListeners()
    } catch(err) {
        console.warn('>> something went wrong');
    }
  }

  render() {
    return null
  }
}

const mapStateToProps = (state) => {
  return {
    presetButtonsMode: state.device.presetButtonsMode,
    updatingFirmware: state.device.updatingFirmware,
    bootloaderMode: state.device.bootloaderMode,
    devicePresetsLoaded: state.editor.devicePresetsLoaded,
    learnModeOpen: state.editor.learnModeOpen,
    selectedPreset: state.editor.selectedPreset,
    selectedLearnBar: state.editor.selectedLearnBar,
    learnModeStrikeCount: state.editor.learnModeStrikeCount,
    currentPreset: state.currentPreset,
    lowNote: state.currentPreset.lowNote,
    octave: state.currentPreset.octave,
    presets: state.presets
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // set connection status
    onConnection: (status) => dispatch(deviceConnection(status)),
    // { onConnection : deviceConnection }
    onDisconnection: (status) => dispatch(deviceConnection(status)),
    // { onDisconnection : deviceConnection }
    onReconnection: (status) => dispatch(deviceConnection('reconnected')),
    // { onReconnection : deviceConnection }
    onSetBootloaderMode: (active) => dispatch(setBootloaderMode(active)),
    // { onSetBootloaderMode: setBootloaderMode }
    onFirmwareUpdateComplete: () => dispatch(firmwareUpdateComplete()),
    // { onReconnection : deviceConnection }
    onSetStatusMessage: (status) => dispatch(setStatusMessage(status)),
    // presets
    onAddPreset: (category, preset) => dispatch(addPreset(category, preset)),
    // { onAddPreset : addPreset }
    onDevicePresetsLoaded: (status) => dispatch(devicePresetsLoaded(status)),
    // UI Sync
    onSelectUI: (control, presets, buttonMode) => dispatch(selectUI(control, presets, buttonMode)),
    // Learn Bar Record
    onSetBarRecord: (barData) => dispatch(setBarRecord(barData)),
    // Strike Count
    onSetStrikeCount: () => dispatch(setLearnStrikeCount())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MalletStationListener)
